var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_990_2211)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_990_2211",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 25
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 22.5C13.3135 22.5017 14.6143 22.2438 15.8278 21.7412C17.0413 21.2385 18.1435 20.501 19.071 19.571C20.001 18.6435 20.7385 17.5413 21.2412 16.3278C21.7438 15.1143 22.0017 13.8135 22 12.5C22.0017 11.1865 21.7438 9.8857 21.2411 8.67222C20.7385 7.45875 20.001 6.35656 19.071 5.42901C18.1435 4.49902 17.0413 3.76151 15.8278 3.25885C14.6143 2.75619 13.3135 2.49831 12 2.50001C10.6865 2.49833 9.3857 2.75623 8.17222 3.25889C6.95875 3.76154 5.85656 4.49904 4.92901 5.42901C3.99904 6.35656 3.26154 7.45875 2.75889 8.67222C2.25623 9.8857 1.99833 11.1865 2.00001 12.5C1.99831 13.8135 2.25619 15.1143 2.75885 16.3278C3.26151 17.5413 3.99902 18.6435 4.92901 19.571C5.85656 20.501 6.95875 21.2385 8.17222 21.7411C9.3857 22.2438 10.6865 22.5017 12 22.5Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 12.5L11 15.5L17 9.5",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_990_2211)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0.5H24V24.5H0V0.5Z",
    fill: "#5EB067"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_990_2211"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessNotification);
export default __webpack_public_path__ + "static/media/success-notification.b4f3d4823464fb12ca011e986854a0fd.svg";
export { ForwardRef as ReactComponent };